import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import HomeIcon from '@material-ui/icons/Home'
import StarIcon from '@material-ui/icons/Star'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'

import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import { colors as colorConstants } from '../constants/colors'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Box from '@material-ui/core/Box'
import { useDispatch, useSelector } from 'react-redux'
import { tagsConstants } from '../constants/tagsConstants'
import { routes } from '../constants/routesConstants'
import { selectTag } from '../actions/digitalMenuActions'
import { push } from 'react-router-redux'
import { createStoreRoute } from '../routes/routeUtils'

const DigitalMenuFooterBar = () => {

  const dispatch = useDispatch()
  const tags = useSelector(loadMenuDataSelectors.getTags)
  const colors = useSelector(loadMenuDataSelectors.getColors)
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)
  const currentRoute = useSelector(state => state.router.location.pathname)

  const useStyles = makeStyles(() => ({
    root: {
      marginTop: '12px',
      position: 'fixed',
      top: 'auto',
      bottom: 0,
      background: colorConstants.DEFAULT_SECONDARY_COLOR,
    },
    container: {
      height: '60px',
      background: colorConstants.DEFAULT_SECONDARY_COLOR,
    },
    label: {
      textAlign: 'center',
      fontFamily: 'abadi-mt-condensed-light, sans-serif',
    },
    actionItem: {
      '&$selected': {
        color: colors.primary
      }
    },
    selected: {}
  }))

  const classes = useStyles()

  const hasFeatured = tags.includes(tagsConstants.FEATURED)
  const hasPromotion = tags.includes(tagsConstants.PROMOTION)

  if (!hasFeatured && !hasPromotion) {
    return <></>
  }

  const handleHomeClick = () => {
    dispatch(push(createStoreRoute(routes.MENU(), storeCode)))
  }

  const handleTagClick = (tag) => () => {
    dispatch(selectTag(tag, storeCode))
  }

  let bottomNavigationValue = ''
  if (currentRoute === createStoreRoute(routes.MENU(), storeCode)) {
    bottomNavigationValue = 'index'
  } else if (currentRoute === createStoreRoute(routes.TAG(tagsConstants.PROMOTION), storeCode)) {
    bottomNavigationValue = tagsConstants.PROMOTION
  } else if (currentRoute === createStoreRoute(routes.TAG(tagsConstants.FEATURED), storeCode)) {
    bottomNavigationValue = tagsConstants.FEATURED
  }

  return <>
    {/*
      DEIXAR PARA DAR OFFSET PARA CIMA
      https://github.com/mui-org/material-ui/issues/10076
    */}
    <Toolbar/>
    <AppBar
      position="fixed"
      className={classes.root}>
      <BottomNavigation
        value={bottomNavigationValue}
        showLabels
        className={classes.container}
      >
        <BottomNavigationAction
          value="index"
          label={
            <Box
              fontSize={18}
              className={classes.label}
              fontWeight="fontWeightBold"
            >
              Início
            </Box>
          }
          onClick={handleHomeClick}
          icon={<HomeIcon/>}
          classes={{
            root: classes.actionItem,
            selected: classes.selected
          }}
        />
        {hasFeatured && <BottomNavigationAction
          value={tagsConstants.FEATURED}
          label={
            <Box
              fontSize={18}
              className={classes.label}
              fontWeight="fontWeightBold"
            >
              Destaques
            </Box>
          }
          onClick={handleTagClick(tagsConstants.FEATURED)}
          icon={<StarIcon/>}
          classes={{
            root: classes.actionItem,
            selected: classes.selected
          }}
        />}
        {hasPromotion && <BottomNavigationAction
          value={tagsConstants.PROMOTION}
          label={
            <Box
              fontSize={18}
              className={classes.label}
              fontWeight="fontWeightBold"
            >
              Promoções
            </Box>
          }
          onClick={handleTagClick(tagsConstants.PROMOTION)}
          icon={<AttachMoneyIcon/>}
          classes={{
            root: classes.actionItem,
            selected: classes.selected
          }}
        />}
      </BottomNavigation>
    </AppBar>
  </>
}

DigitalMenuFooterBar.propTypes = {
  children: PropTypes.any
}

export default DigitalMenuFooterBar
